export const EMAIL_SETTINGS_KEY = {
  TOPIC_DAILY: 'topics_daily',
  TOPIC_WEEKLY: 'topics_weekly',
  AGENCY_DAILY: 'agency_daily',
  AGENCY_WEEKLY: 'agency_weekly',
  ENFORCEMENTS_DAILY: 'enforcements_daily',
  ENFORCEMENTS_WEEKLY: 'enforcements_weekly',
  POLICY_DAILY: 'policy_daily',
  POLICY_WEEKLY: 'policy_weekly',
  TASK_EMAIL_SENDING_TYPE: 'task_email_sending_type',
  SELF_TASKS_ASSIGNED: 'self_tasks_assigned',
  SELF_TASKS_DUE_24_HOURS: 'self_tasks_due_24_hours',
  SELF_TASKS_PAST_DUE: 'self_tasks_past_due',
  SELF_TASKS_COMPLETE: 'self_tasks_complete',
  ORGANIZATION_TASKS_ASSIGNED: 'organization_tasks_assigned',
  ORGANIZATION_TASKS_DUE_24_HOURS: 'organization_tasks_due_24_hours',
  ORGANIZATION_TASKS_PAST_DUE: 'organization_tasks_past_due',
  ORGANIZATION_TASKS_COMPLETE: 'organization_tasks_complete',
  ALERT_EMAIL_DELIVER_TIME: 'alert_email_deliver_time',
  GLASSDOOR_DAILY: 'glassdoor_daily',
  GLASSDOOR_WEEKLY: 'glassdoor_weekly',
  SHARED_ALERT: 'shared_alerts',
  SHARED_FOLDER: 'shared_folders',
  FOLDER_DOCS_DAILY: 'folder_docs_daily',
  FOLDER_DOCS_WEEKLY: 'folder_docs_weekly',
  RELEASE_NOTES: 'release_notes',
  APP_CONTEXT: 'app_contexts'
};

export const APP_CONTEXT = {
  AAI: 'assurance',
  CAI: 'compliance'
} as const;

export const EMAIL_INTERVAL_SETTINGS = {
  INDIVIDUAL: 'individual',
  DAILY: 'daily',
  WEEKLY: 'weekly'
};

export const EMAIL_TIME_SETTINGS_KEY = {
  WEEKDAY: 'weekday',
  TIME: 'time',
  MERIDIEM: 'meridiem'
};

export const MERIDIEM_KEY = {
  AM: 'AM',
  PM: 'PM'
};

export const DEFAULT_TIME_SETTINGS = {
  [EMAIL_TIME_SETTINGS_KEY.WEEKDAY]: 0,
  [EMAIL_TIME_SETTINGS_KEY.TIME]: '08:00',
  [EMAIL_TIME_SETTINGS_KEY.MERIDIEM]: MERIDIEM_KEY.AM
};

export const BYOC_POLICY_UPDATE_EMAIL_SETTING = {
  label: 'Policy Update',
  checkboxes: [
    { key: EMAIL_SETTINGS_KEY.POLICY_DAILY, label: 'Daily Email' },
    { key: EMAIL_SETTINGS_KEY.POLICY_WEEKLY, label: 'Weekly Email' }
  ]
};

export const EMAIL_PREFERENCE_SETTING = {
  title: 'Platform Preference',
  settings: [
    {
      label: 'Please select your preferred platform for emails',
      radios: [
        {
          key: EMAIL_SETTINGS_KEY.APP_CONTEXT,
          value: APP_CONTEXT.AAI,
          label: 'Evolv for Compliance'
        },
        {
          key: EMAIL_SETTINGS_KEY.APP_CONTEXT,
          value: APP_CONTEXT.CAI,
          label: 'Compliance AI'
        }
      ]
    }
  ]
};

export const EMAIL_NOTIFICATION_SETTINGS = {
  SYSTEM_EMAIL_NOTIFICATION_SETTINGS: {
    title: 'System Email Notifications',
    settings: [
      {
        label: 'Topic Update',
        checkboxes: [
          { key: EMAIL_SETTINGS_KEY.TOPIC_DAILY, label: 'Daily Email' },
          { key: EMAIL_SETTINGS_KEY.TOPIC_WEEKLY, label: 'Weekly Email' }
        ]
      },
      {
        label: 'Agency Update',
        checkboxes: [
          { key: EMAIL_SETTINGS_KEY.AGENCY_DAILY, label: 'Daily Email' },
          { key: EMAIL_SETTINGS_KEY.AGENCY_WEEKLY, label: 'Weekly Email' }
        ]
      },
      {
        label: 'Enforcements Update',
        checkboxes: [
          { key: EMAIL_SETTINGS_KEY.ENFORCEMENTS_DAILY, label: 'Daily Email' },
          { key: EMAIL_SETTINGS_KEY.ENFORCEMENTS_WEEKLY, label: 'Weekly Email' }
        ]
      }
    ]
  },
  TASK_EMAIL_NOTIFICATION_SETTINGS: {
    title: 'Task Email Notifications',
    settings: [
      {
        label: 'How would you like to receive task emails',
        radios: [
          {
            key: EMAIL_SETTINGS_KEY.TASK_EMAIL_SENDING_TYPE,
            value: EMAIL_INTERVAL_SETTINGS.INDIVIDUAL,
            label: 'Individual task emails'
          },
          {
            key: EMAIL_SETTINGS_KEY.TASK_EMAIL_SENDING_TYPE,
            value: EMAIL_INTERVAL_SETTINGS.DAILY,
            label: 'Daily task summary emails'
          },
          {
            key: EMAIL_SETTINGS_KEY.TASK_EMAIL_SENDING_TYPE,
            value: EMAIL_INTERVAL_SETTINGS.WEEKLY,
            label: 'Weekly task summary emails'
          }
        ]
      },
      {
        label: 'Your Tasks',
        checkboxes: [
          { key: EMAIL_SETTINGS_KEY.SELF_TASKS_ASSIGNED, label: 'Tasks Assigned' },
          { key: EMAIL_SETTINGS_KEY.SELF_TASKS_DUE_24_HOURS, label: 'Due in 24 hours' },
          { key: EMAIL_SETTINGS_KEY.SELF_TASKS_PAST_DUE, label: 'Past Due' },
          { key: EMAIL_SETTINGS_KEY.SELF_TASKS_COMPLETE, label: 'Task Complete' }
        ]
      },
      {
        label: 'Organization Tasks (notify)',
        checkboxes: [
          { key: EMAIL_SETTINGS_KEY.ORGANIZATION_TASKS_ASSIGNED, label: 'Tasks Assigned' },
          { key: EMAIL_SETTINGS_KEY.ORGANIZATION_TASKS_DUE_24_HOURS, label: 'Due in 24 hours' },
          { key: EMAIL_SETTINGS_KEY.ORGANIZATION_TASKS_PAST_DUE, label: 'Past Due' },
          { key: EMAIL_SETTINGS_KEY.ORGANIZATION_TASKS_COMPLETE, label: 'Task Complete' }
        ]
      }
    ]
  },
  SHARE_NOTIFICATIONS_SETTINGS: {
    title: 'Share Notifications',
    settings: [
      {
        checkboxes: [
          {
            key: EMAIL_SETTINGS_KEY.SHARED_ALERT,
            label: 'Receive Shared Alert Email'
          },
          {
            key: EMAIL_SETTINGS_KEY.SHARED_FOLDER,
            label: 'Receive Shared Folder Email'
          }
        ]
      }
    ]
  },
  CHANGE_NOTIFICATIONS_SETTINGS: {
    title: 'Change Notifications',
    settings: [
      {
        label: 'Notify me when a document is added to a folder',
        checkboxes: [
          {
            key: EMAIL_SETTINGS_KEY.FOLDER_DOCS_DAILY,
            label: 'Daily Email'
          },
          {
            key: EMAIL_SETTINGS_KEY.FOLDER_DOCS_WEEKLY,
            label: 'Weekly Email'
          }
        ]
      }
    ]
  },
  GLASSDOOR_EMAIL_NOTIFICATION_SETTINGS: {
    title: 'Glassdoor Email Notifications',
    settings: [
      {
        label: 'Glassdoor Update',
        checkboxes: [
          { key: EMAIL_SETTINGS_KEY.GLASSDOOR_DAILY, label: 'Daily Email' },
          { key: EMAIL_SETTINGS_KEY.GLASSDOOR_WEEKLY, label: 'Weekly Email' }
        ]
      }
    ]
  },
  RELEASE_NOTES_EMAIL_NOTIFICATION_SETTINGS: {
    title: 'Product Notifications',
    settings: [
      {
        label: 'Release Notes',
        checkboxes: [
          { key: EMAIL_SETTINGS_KEY.RELEASE_NOTES, label: 'Receive release notes email' }
        ]
      }
    ]
  }
};
